import React, {FunctionComponent, useContext} from 'react';
import './ContractContent.scss';
import {Invoice} from '../../models/invoice.model';
import {InvoiceContext} from '../../context/InvoiceContext';
import {SanitizedHtml} from '@flicent/fieldpulse-react-component-library-frontend';

const sanitizeHtmlOptions = {
    allowedAttributes: {
        '*': ['style', 'href', 'target'],
        img: ['src', 'alt', 'width', 'height', 'style'],
        li: ['class']
    },
    allowedTags: [
        'address', 'article', 'aside', 'footer', 'header', 'h1', 'h2', 'h3', 'h4',
        'h5', 'h6', 'hgroup', 'main', 'nav', 'section', 'blockquote', 'dd', 'div',
        'dl', 'dt', 'figcaption', 'figure', 'hr', 'li', 'main', 'ol', 'p', 'pre',
        'ul', 'a', 'abbr', 'b', 'bdi', 'bdo', 'br', 'cite', 'code', 'data', 'dfn',
        'em', 'i', 'kbd', 'mark', 'q', 'rb', 'rp', 'rt', 'rtc', 'ruby', 's', 'samp',
        'small', 'span', 'strong', 'sub', 'sup', 'time', 'u', 'var', 'wbr', 'caption',
        'col', 'colgroup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr',
        'img'
    ],
    parseStyleAttributes: false,
};

export const ContractContent: FunctionComponent = () => {
    const invoice: Invoice = useContext(InvoiceContext);

    return (
        <p className='contract-content'>
            <SanitizedHtml htmlContent={invoice.contract_content} sanitizeOptions={sanitizeHtmlOptions}/>
        </p>
    );
};
